var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-album"},[_c('form-file',{attrs:{"name":("file_" + _vm.index),"uploadFront":"true","folder":"audiobooks"}}),_vm._v(" "),_c('form-input',{attrs:{"name":("name_" + _vm.index)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad7a3778","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/create-form/Audio.vue
// module id = null
// module chunks = 